import { put } from 'redux-saga/effects';
import { track } from '../../analytics/analyticsClient';
import trackEvents from '../../analytics/trackEvents';
import api from '../../helpers/api';
import * as TimesheetRowsActions from '../TimesheetRows/actions';
import { selectToken } from '../selectors';
import { store } from '../store';
import { setSyncStatus } from '../timesheets-slice';
import * as actions from './actions';

export function* createTimesheetEntryRequestSaga(payload: any): Generator<any, void, any> {
  try {
    const _store = store.getState();
    const res = yield api.send({
      url: `/timesheets/${payload.data.timesheetId}/entries`,
      method: 'POST',
      data: { ...payload.data.data },
      token: selectToken(_store),
    });
    yield put(actions.createTimesheetEntryRequestSuccess(res));
    yield put(setSyncStatus({ timesheetId: payload.data.timesheetId, synced: false }));
    yield put(TimesheetRowsActions.getTimesheetRowRequest({ rowId: res.timesheetRowId, timesheetId: payload.data.timesheetId }));
    track(trackEvents.TIMESHEET_ENTRY_CREATE);
  } catch (error) {
    if (payload.data.errCb) payload.data.errCb();
    yield put(actions.createTimesheetEntryRequestFailure(error));
  } finally {
    yield put(actions.createTimesheetEntryRequestFinally(payload.data.data));
  }
}

export function* deleteTimesheetEntryRequestSaga(payload: any): Generator<any, void, any> {
  try {
    yield api.send({
      url: `/timesheets/${payload.data.timesheetId}/entries/${payload.data.entryId}`,
      method: 'DELETE',
      token: selectToken(store.getState()),
    });
    yield put(actions.deleteTimesheetEntryRequestSuccess({ entryId: payload.data.entryId }));
    yield put(setSyncStatus({ timesheetId: payload.data.timesheetId, synced: false }));
    track(trackEvents.TIMESHEET_ENTRY_DELETE);
  } catch (error) {
    yield put(actions.deleteTimesheetEntryRequestFailure(error));
  }
}

export function* getTimesheetEntriesRequestSaga(payload: any): Generator<any, void, any> {
  try {
    const res = yield api.send({
      url: `/timesheets/${payload.data.timesheetId}/entries`,
      method: 'GET',
      token: selectToken(store.getState()),
    });
    yield put(actions.getTimesheetEntriesRequestSuccess(res));
  } catch (error) {
    console.error(error);
    yield put(actions.getTimesheetEntriesRequestFailure(error));
  }
}

export function* updateTimesheetEntryRequestSaga(payload: any): Generator<any, void, any> {
  try {
    const timesheetId = payload.data.timesheetId;
    const res = yield api.send({
      url: `/timesheets/${timesheetId}/entries/${payload.data.entryId}`,
      method: 'PUT',
      data: payload.data.data,
      token: selectToken(store.getState()),
    });
    yield put(actions.updateTimesheetEntryRequestSuccess(res));
    yield put(setSyncStatus({ timesheetId: payload.data.timesheetId, synced: false }));
    yield put(actions.getTimesheetEntriesRequest({ timesheetId }));
    yield put(TimesheetRowsActions.getTimesheetRowRequest({ rowId: res.timesheetRowId, timesheetId }));
    track(trackEvents.TIMESHEET_ENTRY_UPDATE);
  } catch (error) {
    payload.data.errCb?.();
    yield put(actions.updateTimesheetEntryRequestFailure(error));
  } finally {
    yield put(actions.updateTimesheetEntryRequestFinally(payload.data?.entryId));
  }
}
